<template lang="pug">
  div( class="logout-overlay" )
    MLoadingSpinner( class="spinner" )
</template>

<style lang="scss" scoped>
.logout-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;

  .spinner {
    position: absolute;
    top: 50%;
    left: 50%;
    font-size: 5em;
    color: #fff;
    transform: translate(-50%, -50%);
  }
}
</style>

<script>
import Vue from 'vue'
export default Vue.extend({
  beforeCreate() {
    this.$moonpull.logout()
  }
})
</script>
